import { useEffect } from 'react';

export function useMutationReset(reset: () => void): void {
  useEffect(() => () => reset(), [reset]);
}
